export default __webpack_public_path__ + "static/media/displayText.41023f2c.png";